import { render, staticRenderFns } from "./ServiceReview.vue?vue&type=template&id=cbe25ef2&scoped=true"
import script from "./ServiceReview.vue?vue&type=script&lang=js"
export * from "./ServiceReview.vue?vue&type=script&lang=js"
import style0 from "./ServiceReview.vue?vue&type=style&index=0&id=cbe25ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe25ef2",
  null
  
)

export default component.exports